import axios from 'axios';
import { REQUEST_TIMEOUT } from '../constants/general';
import { generateXB3TraceID, getChannelID, getHost, isSsr, getTmxId, } from '../utils/general';
import { getAuthorizationToken } from '../utils/user';
const baseurl = getHost();
const channelId = getChannelID();
const TMXProfileID = isSsr ? '' : getTmxId();
const baseConfig = {
    baseURL: baseurl,
    headers: {
        TMXProfileID,
    },
    timeout: REQUEST_TIMEOUT,
};
const b2cConfig = {
    baseURL: baseurl,
    headers: {
        channelId,
        TMXProfileID,
        Authorization: getAuthorizationToken(),
        'Content-Type': 'application/json',
        Accept: 'application/json',
    },
    timeout: REQUEST_TIMEOUT,
};
const b2bConfig = {
    baseURL: baseurl,
    headers: {
        channelId,
        TMXProfileID,
        'X-B3-TraceId': generateXB3TraceID(),
    },
    timeout: REQUEST_TIMEOUT,
};
const apiBase = axios.create(baseConfig);
const apiB2C = axios.create(b2cConfig);
const apiB2B = axios.create(b2bConfig);
export { apiBase, apiB2C, apiB2B };
